<div class="container" loading-spin [isLoading]="!isPrepareDataReady" [loadingSize]="'big'">
    <div *ngIf="isPrepareDataReady" class="tab-set-container">
        <tam-tab-set tid="home_screen_tabs" [selectedIndex]="selectedIndex" (selectChange)="onTabSelectChange($event)"
            [draggable]="draggableTab" (editTitle)="onTabTitleBlur($event)" (reSortTab)="onTabSort($event)">
            <tam-tab *ngFor="let item of pages;trackBy:trackByFn" [title]="item.name" [editable]="item.editable"
                [editing]="item.editing" (contextmenu)="showPageContextMenu($event,item)">
            </tam-tab>
            <ng-template #extra>
                <div class="extra_add">
                    <smart-icon tid="add_icon" name="add" class="light" (click)=showPagesContextMenu($event,item)>
                    </smart-icon>
                </div>
            </ng-template>
        </tam-tab-set>
    </div>
    <ng-container *ngIf="isPrepareDataReady">
        <div class="page-box" *ngFor="let page of pages;trackBy:trackByFn"
            [style.display]="page.id === currentPageId ? 'block' : 'none'">
            <div class="screen-container" loading-spin [isLoading]="isScreenLoading[page.id]" [loadingSize]="'big'">
                <div class="research-container" *ngIf="page.screenType === 'research' && page.config">
                    <research-screen [config]="page.config"></research-screen>
                </div>
                <div class="dashboard-container" *ngIf="page.screenType === 'dashboard'" loading-spin
                    [isLoading]="reloadingDashboard" [loadingSize]="'big'">
                    <dashboard-screen [screenKey]="page.screenId" [storeKey]="page.id" [screenType]="page.screenType"
                        [loadingSpecificScreen]="loadingSpecificScreen" [firstPageTabId]="firstTabPageId"
                        [actionSubject$]="actionSubject$" [pageType]="'homeScreen'">>
                    </dashboard-screen>
                </div>
                <div class="workflow-container" *ngIf="page.screenType === 'workflow'" loading-spin
                    [isLoading]="reloadingWorkflow" [loadingSize]="'big'">
                    <tam-workflow-kanban-screen [screenId]="page.screenId" [id]="page.workflowId" [pageId]="page.id"
                        [isShowAsTab]="true" [firstPageTabId]="firstTabPageId" [actionSubject$]="actionSubject$"
                        [loadingSpecificScreen]="loadingSpecificScreen">
                    </tam-workflow-kanban-screen>
                </div>
            </div>
        </div>
    </ng-container>
    <tam-context-menu [config]="contextMenuConfig"></tam-context-menu>

    <context-menu #screensMenu>
        <ng-container *ngFor="let menu of this.screenMenuContainer;trackBy:trackByFn">
            <context-menu #screenSubMenu [disabled]="menu.items && menu.items.length === 0">
                <ng-template contextMenuItem *ngFor="let subMenu of menu.items;trackBy:trackByFn"
                    (execute)="onAddScreen(subMenu)">
                    <div class="screen-sub-menu-container">
                        <span [title]="subMenu.caption" kendoTooltip>{{subMenu.caption}}</span>
                    </div>
                </ng-template>
            </context-menu>
            <ng-template contextMenuItem let-item [subMenu]="menu.type && screenSubMenu">
                <div class="screen-menu-item-container">
                    <div class="screen-menu-item">
                        <smart-icon [name]="menu.iconName" class="menu-item-icon"></smart-icon>
                        <span>{{menu.caption}}</span>
                    </div>
                    <div *ngIf="menu.items && menu.items.length > 0">
                        <smart-icon name="angle-right"></smart-icon>
                    </div>
                </div>
            </ng-template>
        </ng-container>
        <ng-template contextMenuItem divider="true" *ngIf="!isIPAD"></ng-template>
        <ng-template contextMenuItem (execute)="onAddScreen('')" *ngIf="!isIPAD">
            <div class="screen-menu-item-container">
                <smart-icon name="add"></smart-icon>
                <span>&nbsp;&nbsp;&nbsp;Create Research View</span>
            </div>
        </ng-template>
    </context-menu>
</div>